import { render, staticRenderFns } from "./VEntryList.vue?vue&type=template&id=c8a1ade8&scoped=true"
import script from "./VEntryList.vue?vue&type=script&lang=ts"
export * from "./VEntryList.vue?vue&type=script&lang=ts"
import style0 from "./VEntryList.vue?vue&type=style&index=0&id=c8a1ade8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1ade8",
  null
  
)

export default component.exports